import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { getSafeSessionStorage } from '../util/tokenStorage'

const MEMORY_STORAGE = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
}

const resolveStorage = () => getSafeSessionStorage() || MEMORY_STORAGE

const useUserStore = create(
  persist(
    (set, get) => ({
      patient: null,
      isAuth: false,
      setPatient: patient => set({ patient }),
      setIsAuth: isAuth => set({ isAuth }),
    }),
    {
      name: 'tbd-pu',
      getStorage: resolveStorage,
    }
  )
)

export default useUserStore
